/** @format */
import React from 'react';
import { useState } from 'react';
import { toFilterVOS } from 'components/FilterPod';
import { useStyles } from './style';
import { useEffect } from 'react';
import { Empty, PageContainer, FilterPod, LoadingPage, PaginationComponenets } from 'components';
import { Box, Grid } from '@mui/material';
import { CustomerItem } from './components';
import InitFilters from './constans/InitFilters';
import Services from './services';
import { generateData } from './components/Utils';
import FilterButton from 'components/FilterPod/FilterButton';
import { getDynamicObjectAction } from 'utility';

const COUNT_DATA_PER_PAGE = 12;
const customersList = ({ handleChangeTab }) => {
  const [customers, setCustomers] = useState([]);
  const [filters, setFilters] = useState(InitFilters);
  const [totalCount, setTotoalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const [loading, setLoading] = useState(false);
  const actionsList =
    getDynamicObjectAction([
      'followersListFinancialPage',
    ])
  // --HOOKS--//
  const classes = useStyles();

  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const handleCloseFilterDialog = () => setOpenFilterDialog(false);

  useEffect(() => {
    if (actionsList['followersListFinancialPage']) {
      getList();
      paginationOnChange({
        page: currentPage === 0 ? 1 : currentPage,
        pageSize: 5,
        pageNumber: currentPage === 0 ? 0 : currentPage - 1,
        changeData: true,
      });
    }
  }, [currentPage]);


  // --API--//
  const getList = async (f = filters, isChangeFilter = false) => {
    try {
      setLoading(true);

      // Handle Order By
      const orderBy = [];
      const filter = toFilterVOS([...f]);

      const params = {
        page: isChangeFilter ? 0 : (currentPage - 1),
        size: COUNT_DATA_PER_PAGE,
      };

      const data = {
        filterVOS: filter ?? [],
        parentParams: [],
        orderByElementVOS: orderBy ?? [],
      };

      const res = await Services.getClients(data, params);


      let list = [];
      if (res.result.rows) {
        list = generateData(res.result.rows, {
          page: currentPage - 1,
          pageSize: COUNT_DATA_PER_PAGE,
        });
      }

      setCustomers(list);
      setTotoalCount(res?.result?.totalCount);


      setLoading(false);

    } catch (error) {
      setLoading(false);
    }
  };

  // --OTHER FUNCTIONS--//




  // تابع برای تغییر وضعیت انتخاب همه ردیف‌ها
  const paginationOnChange = async (param) => {
    if (param?.changeData) {
      // صفحه جاری در این بخش ست میش
      setCurrentPage(param?.page == 0 ? 1 : param?.page);
    }
  };

  const onFiltersChange = (newFilters) => {
    //setCurrentPage(0);
    setFilters(newFilters);
    getList(newFilters, true);
  };

  return (
    <>
      <Grid item xs={12}>
        <Box display="flex" justifyContent='end' alignItems="flex-end" style={{ marginBottom: 16 }}>
          <FilterButton
            setOpenFilterDialog={setOpenFilterDialog}
            filters={filters}
          />
        </Box>
        <Box>
          <FilterPod
            filters={filters}
            onChange={onFiltersChange}
            openFilterDialog={openFilterDialog}
            setOpenFilterDialog={setOpenFilterDialog}
            handleCloseFilterDialog={handleCloseFilterDialog}
          />
        </Box>
      </Grid>
      {loading ? <LoadingPage /> : null}
      {customers?.length === 0 && !loading ? <Empty /> : null}
      <Grid container spacing={2}>
        {!loading
          ? customers?.map((v, k) => (
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <CustomerItem
                key={k}
                id={v?.id}
                username={v?.username}
                fullName={v?.fullName}
                image={v?.image}
                userId={v?.userId}
              />
            </Grid>
          ))
          : null}
      </Grid>
      {!loading && customers?.length > 0 ? (
        <Grid justifyContent="center" container style={{ marginTop: 16 }}>
          <PaginationComponenets
            itemsPerPage={12}
            currentPage={currentPage}
            pageCount={totalCount}
            onChange={paginationOnChange}
            removePrePage={true}
          />
        </Grid>
      ) : null}
    </>
  );
};

export default customersList;

